import i18n from 'i18next'

export const DATASET_STARTED = 'INGESTION_STARTED'
export const DATASET_DONE = 'INGESTION_DONE'
export const DATASET_FAILED = 'INGESTION_FAILED'
export const DATASET_TIMED_OUT = 'INGESTION_TIMED_OUT'
export const DATASET_NOT_VALID = 'INGESTION_NOT_VALID'

export const DATASET_MANUAL_SYNC = 'Manual sync'
export const DATASET_MANUAL_UPLOAD = 'Manual upload'

export const OPTIMIZATION_ORDERS = 'Orders'
export const OPTIMIZATION_RESOURCES = 'Resources'

export type DatasetStatus =
  | typeof DATASET_STARTED
  | typeof DATASET_DONE
  | typeof DATASET_FAILED
  | typeof DATASET_TIMED_OUT
  | typeof DATASET_NOT_VALID

export type DatasetType =
  | typeof DATASET_MANUAL_SYNC
  | typeof DATASET_MANUAL_UPLOAD

export type OptimizationType =
  | typeof OPTIMIZATION_ORDERS
  | typeof OPTIMIZATION_RESOURCES

export type Dataset = {
  id: number
  status: DatasetStatus
  name: string
  createdAt?: Date
  endedAt?: Date
  updatedAt?: Date
  unavailabilitiesUpdatedAt?: Date
  exportDate?: Date
  type?: DatasetType
}

export const getDatasetStatusStr = (status: DatasetStatus): string => {
  const name = {
    [DATASET_STARTED]: i18n.t('Running'),
    [DATASET_DONE]: i18n.t('Completed'),
    [DATASET_FAILED]: i18n.t('Failed'),
    [DATASET_TIMED_OUT]: i18n.t('Timed out'),
    [DATASET_NOT_VALID]: i18n.t('Not valid'),
  }

  return name[status]
}

export const getDatasetTypeStr = (type: DatasetType): string => {
  const name = {
    [DATASET_MANUAL_SYNC]: i18n.t('Manual sync'),
    [DATASET_MANUAL_UPLOAD]: i18n.t('Manual upload'),
  }

  return name[type]
}

export const getOptimizationTypeStr = (type: OptimizationType): string => {
  const name = {
    [OPTIMIZATION_ORDERS]: i18n.t('Orders'),
    [OPTIMIZATION_RESOURCES]: i18n.t('Resources'),
  }

  return name[type]
}
